import {CostOfCapitalComponent} from '../../../../../../pages';
import {TenderAnalyticsCostOfCapitalResolver} from '../../../../../resolvers';
import { Route } from '@angular/router';

export const costOfCapitalRoute: Route = {
    path: 'cost-of-capital',
    component: CostOfCapitalComponent,
    resolve: {
        cost_of_capital: TenderAnalyticsCostOfCapitalResolver,
    },
};
